import React from "react";
import {Tab, Tabs} from "material-ui/Tabs";
import IconButton from "material-ui/IconButton";
import Close from "material-ui/svg-icons/content/clear";
import LiveList from "./LiveList";
import NoticeList from "./NoticeList";
import Disqus from "./Disqus";
import Setting from "./Setting";
import "./LiveDialog.css";
import store from "../../../lib/store";


export default class LiveDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = store.getState();
        this.liveEventHandler = false;
        this.unsubscribe = store.subscribe(function(){
            this.setState(store.getState());
        }.bind(this));

    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    /*componentWillReceiveProps(nextProps){
        if(this.props.dialogProps.open && this.props.dialogProps.open != nextProps.dialogProps.open) {
            // close
            this.willCloseHandler();
        } else if(!this.props.dialogProps.open && this.props.dialogProps.open != nextProps.dialogProps.open) {
            // open
            this.willOpenHandler();
        }
    }*/

    componentWillMount(){
        /*
        firebase.database().ref(`campaign/${this.props.campaignId}/info`).once('value').then(function(sp){
            if(firebase.auth().currentUser.uid === sp.val().userKey)
                this.setState({isAdmin:true});
        }.bind(this));
        */

    }


    tabHandler(tab) {
        this.setState({liveMode:tab.props.type});
    }


    openHandler() {
        this.setState({liveOpen: true, liveMode: this.state.liveMode ? this.state.liveMode : 'live'});
    }

    closeHandler() {
        this.setState({liveOpen: false});
    }

    generateSetting(){
        if(this.state.campaignUserLevel === 'ADMIN'){
            return (
                <Tab label="설정" type="setting" value="setting" onActive={this.tabHandler.bind(this)}>
                    <div className="setting_tab tab_content">
                        {this.state.liveMode === 'setting' ? <Setting campaignId={this.props.campaignId}/> :<div/>}
                    </div>
                </Tab>
            );
        }
        return <div style={{display:'none'}}></div>;
    }

    generateDialog(){
        return (
                <div
                    className="LiveDialog"
                    style={{
                        display: this.state.liveOpen ? 'block' : 'none',
                        // display:'block',
                        height: '100vh',
                        width: '100vw',
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        backgroundColor: 'white',
                        boxSizing: 'border-box',
                        zIndex: 10000
                    }}
                >
                    <IconButton
                        style={{
                            float: 'right',
                            color: 'rgb(255, 64, 129)'
                        }}
                        onTouchTap={function () {
                            store.dispatch({type:'LIVE_CLOSE'})
                            this.setState({liveOpen: false});
                        }.bind(this)}
                    >
                        <Close color="black"/>
                    </IconButton>
                    <Tabs value={this.state.liveMode}
                          contentContainerStyle={{
                              padding: '0',
                              borderTop: '1px solid rgb(0, 188, 212)',
                              height: '100%',
                              overflowY: 'scroll'
                          }}
                          tabItemContainerStyle={{
                              width: '300px'
                          }}
                          style={{height: '100%'}}
                          className="LiveTab"
                    >
                        <Tab label="타임라인" type="live" value="live" onActive={this.tabHandler.bind(this)}
                             style={{
                                 borderRight: '1px solid white'
                             }}
                        >
                            <div className="disqus_tab tab_content">
                                {this.state.liveMode === 'live' ? <LiveList campaignId={this.props.campaignId}/> :
                                    <div/>}
                            </div>
                        </Tab>
                        <Tab label="토론" type="disqus" value="disqus" onActive={this.tabHandler.bind(this)}>
                            <div className="disqus_tab tab_content">
                                {this.state.liveMode === 'disqus' ? <Disqus campaignId={this.props.campaignId}/> :
                                    <div/>}
                            </div>
                        </Tab>
                        <Tab label="공지사항" type="notice" value="notice" onActive={this.tabHandler.bind(this)}>
                            <div className="notice_tab tab_content">
                                {this.state.liveMode === 'notice' ? <NoticeList campaignId={this.props.campaignId}/> :<div/>}
                            </div>
                        </Tab>
                        {this.generateSetting()}
                    </Tabs>
                </div>
        );
    }

    render() {
        return (
            <div>

                {this.state.liveOpen ? this.generateDialog() : <div style={{display:'none'}}/>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/LiveDialog.js